const styles = {
  flex: {
    display: "flex",
    flexDirection: "column",
  },
};

export default styles;
